import React from 'react';
import QRCode from "react-qr-code";

// material-ui
import { useTheme } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import './RedQuickScrollDialog.scss'
// ===============================|| UI DIALOG - SCROLLABLE ||=============================== //

export type scrollType = 'body' | 'paper' | undefined;

export default function RedQuickQRCode(props: any) {
    const theme = useTheme();
    const [scroll, setScroll] = React.useState<scrollType>('body');

    const handleClose = () => {
        if (props.close) {
            props.close();
        }
    };

    const descriptionElementRef: React.Ref<HTMLSelectElement> = React.useRef(null);
    React.useEffect(() => {
        if (props?.open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement?.focus();
            }
        }
    }, [props?.open]);

    return (
        <Grid item xs={12} sm={12} lg={12} sx={{ pt: { xs: 2, sm: '0 !important' } }}>
            <QRCode value={props.value || ''} />
        </Grid>

    );
}
